import { BotProtectionMethod } from './bot-protection';
import type { AuthenticationMethodType } from '@cognitoforms/types/server-types/model/authentication-method-type';
import { serviceRequest } from './service-request';
import type { InitMultifactorModel } from 'node_modules/@cognitoforms/types/server-types/services/infrastructure/authentication/init-multifactor-model';

export async function initiateEmailAuthentication(email: string, thumbprint: string, returnUrl: string, requiredOrgCode: string, requiredUser: string) {
	return serviceRequest('auth/email', { email, thumbprint, returnUrl, requiredOrgCode, requiredUser }, { method: 'POST' });
}

export async function initiateSocialAuthentication(token: string, authMethodType: AuthenticationMethodType, thumbprint: string, returnUrl: string, requiredOrgCode: string, requiredUser: string, source: string, details: string, fromSignup: boolean) {
	return serviceRequest(`auth/external/${authMethodType}`, { token, thumbprint, returnUrl, requiredOrgCode, requiredUser, source, details, fromSignup }, { method: 'POST' });
}

export async function passwordLogin(password: string, rememberMe: boolean, authToken: string) {
	return serviceRequest('auth/email/password', { password, rememberMe, authToken }, { method: 'POST' });
}

export async function signupWithEmail(email: string, password: string, name: string, authToken: string, source: string, details: string) {
	return serviceRequest('auth/email/signup', { email, password, name, authToken, source, details }, { method: 'POST' });
}

export async function forgotPassword(authToken: string): Promise<void> {
	return serviceRequest('auth/forgot-password', { authToken: authToken }, { method: 'POST' });
}

export async function resetPassword(passwordResetCode: string, password: string, thumbprint: string) {
	return serviceRequest('auth/reset-password', { passwordResetCode: passwordResetCode, password: password, thumbprint }, { method: 'POST', botProtectionMethod: [BotProtectionMethod.NoBots, BotProtectionMethod.Recaptcha] });
}

export async function validateResetCode(passwordResetCode: string) {
	return serviceRequest('auth/reset-password/validate', { passwordResetCode: passwordResetCode }, { method: 'POST' });
}

export async function loginWithDeviceVerification(verificationCode: string, authToken: string, rememberMe: boolean) {
	return serviceRequest('auth/device-verification/login', { verificationCode, authToken, rememberMe }, { method: 'POST' });
}

export async function signupWithDeviceVerification(verificationCode: string, authToken: string, rememberMe: boolean) {
	return serviceRequest('auth/device-verification/signup', { verificationCode, authToken, rememberMe }, { method: 'POST' });
}

export async function resendDeviceVerificationCode(authToken: string) {
	return serviceRequest('auth/resend-device-verification-code', { authToken }, { method: 'POST' });
}

export async function multifactorVerification(code: string, authToken: string, rememberMe: boolean) {
	return serviceRequest('auth/multifactor-verification', { code, authToken, rememberMe }, { method: 'POST' });
}

export async function sendMultifactorBackupCode(authToken: string) {
	return serviceRequest('auth/mfa-backup-code', { authToken }, { method: 'POST' });
}

export function initEnableMultifactor(): Promise<InitMultifactorModel> {
	return serviceRequest('auth/mfa/initialize', null, { method: 'POST' });
}

export function enableMultifactor(backupEmail: string, secret: string, otp: string, organizationCode: string) {
	return serviceRequest('auth/mfa/enable', { backupEmail, secret, otp, organizationCode }, { method: 'POST' });
}

export function acceptPortalConsentAndAuthenticate(authToken: string) {
	return serviceRequest('auth/guest/accept-consent-and-authenticate', { authToken }, { method: 'POST' });
}

export function acceptPortalConsent(authToken: string) {
	return serviceRequest('auth/guest/accept-consent', { authToken }, { method: 'POST' });
}

export function authenticateGuestPostRegistration(authToken: string) {
	return serviceRequest('auth/guest/post-registration-login', { authToken }, { method: 'POST' });
}